// Logos de marque — fallback typographique propre (aucun logo officiel dans le dépôt).
import React from "react";

export const BrandLogo = ({ brand, size = 44, testId }) => {
  if (!brand) return null;
  const fs = brand.label.length > 4 ? size * 0.21 : size * 0.3;
  return (
    <span data-testid={testId} className="ms-brand" style={{ width: size, height: size, background: brand.bg, color: brand.fg, fontSize: fs }}>
      {brand.label}
    </span>
  );
};

export const InitialsAvatar = ({ name, color = "#10B981", size = 44, testId }) => (
  <span data-testid={testId} className="ms-brand" style={{ width: size, height: size, background: `${color}22`, color, fontSize: size * 0.34, border: `1.5px solid ${color}55` }}>
    {String(name || "?").trim().slice(0, 1).toUpperCase()}
  </span>
);
